import type { ReactNode } from 'react';

/** Einheitlicher Seitenkopf (Titel + Untertitel + Aktionen) - sorgt für konsistente Abstände/Hierarchie über alle Seiten hinweg statt jeder Seite ihr eigenes Ad-hoc-Layout. */
export function PageHeader({ title, description, actions }: { title: string; description?: string; actions?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-4 md:mb-8">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-ivory-100 md:text-3xl">{title}</h1>
        {description && <p className="mt-1.5 text-sm text-ivory-500">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
